// extracted by mini-css-extract-plugin
export default {"steps":"steps__3NjgZ"};